<template>
  <div class="wg-col wg-xs-12" style="padding: 2%">
    <wg-modal
      v-if="showEventAnalytics"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="showEventAnalytics = false"
    >
      <div slot="header" class="com-anm22-app-text-xl">
        <span>{{
          $anm22.strLang(lang, "Event analytics", "Statistiche evento")
        }}</span>
      </div>
      <div slot="body">
        <span>{{
          $anm22.strLang(
            lang,
            "Total people tickets",
            "Totale biglietti persone",
          )
        }}</span>
        <div class="wg-col">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="eventAnalytics.peopleTicketsNum"
            disabled=""
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{
          $anm22.strLang(lang, "Total vehicle tickets", "Totale pass veicoli")
        }}</span>
        <div class="wg-col">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="eventAnalytics.vehicleTicketsNum"
            disabled=""
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{
          $anm22.strLang(
            lang,
            "Total hospitality ticket",
            "Totale pass hospitality",
          )
        }}</span>
        <div class="wg-col">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="eventAnalytics.foodTicketsNum"
            disabled=""
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{
          $anm22.strLang(lang, "Total SIAE codes", "Totale sigilli SIAE")
        }}</span>
        <div class="wg-col">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="eventAnalytics.siaeCodesNum"
            disabled=""
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{
          $anm22.strLang(
            lang,
            "Available SIAE codes",
            "Sigilli SIAE disponibili",
          )
        }}</span>
        <div class="wg-col">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="eventAnalytics.availableSiaeCodesNum"
            disabled=""
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{
          $anm22.strLang(
            lang,
            "Total access number",
            "Totale smarcature eseguite",
          )
        }}</span>
        <div class="wg-col">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="eventAnalytics.gateInNum"
            disabled=""
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{
          $anm22.strLang(
            lang,
            "Number of single tickets checked at the entrance",
            "Numero dei singoli biglietti smarcati",
          )
        }}</span>
        <div class="wg-col">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="eventAnalytics.cardInNum"
            disabled=""
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
      </div>
    </wg-modal>

    <wg-modal
      v-if="showHospitalityList"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="showHospitalityList = false"
    >
      <div slot="header" class="com-anm22-app-text-xl">
        <span>{{ hospitalityListTitle }}</span>
      </div>
      <div slot="body">
        <div class="hospitality-list-counter">
          {{ $anm22.strLang(lang, "Results:", "Risultati:") }} {{ hospitalityTickets.length }}
        </div>
        <div
          v-for="(ticket, tIndex) in sortedHospitalityTickets"
          :key="'t-' + tIndex"
          class="hospitality-list-item"
        >
          <span style="font-weight: bold"
            >{{ ticket.lastName }} {{ ticket.firstName }}
            {{
              !ticket.lastName && !ticket.firstName ? "[Nessun nome]" : ""
            }}</span
          >
          {{ ticket.name }} {{ !ticket.name ? "[Azienda ND]" : "" }}
        </div>
        <div v-if="hospitalityTickets.length <= 0 && hospitalityListMode == 'reservation'">
          {{ $anm22.strLang(lang, "Empty list", "Nessun ospite prenotato") }}
        </div>
        <div v-if="hospitalityTickets.length <= 0 && hospitalityListMode == 'gate'">
          {{ $anm22.strLang(lang, "Empty list", "Nessun pass smarcato") }}
        </div>
      </div>
    </wg-modal>

    <div style="font-size: 24px" class="com-anm22-app-text-m">
      {{ $anm22.strLang(lang, "Analytics", "Statistiche") }}
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>

    <div class="events-list">
      <div
        :class="['wg-row', 'event-row', isSubevent(event) ? 'subevent' : '']"
        v-for="(event, index) in events"
        :key="'event-' + index"
      >
        <div class="event-preview">
          <div class="title">
            <span style="font-weight: bold">{{ getEventName(event) }}</span>
            {{ $moment.unix(event.startTimestamp).format("YYYY-MM-DD") }} -
            {{ $moment.unix(event.endTimestamp).format("YYYY-MM-DD") }}
          </div>
        </div>
        <div v-if="!isSubevent(event)" class="event-box">
          <div class="export">
            <input
              type="button"
              class="com-anm22-input-button"
              @click="openEventAnalytics(event.idWorldEvent)"
              :value="$anm22.strLang(lang, 'Analytics', 'Statistiche')"
            />
          </div>
          <div class="export">
            <input
              type="button"
              class="com-anm22-input-button"
              @click="downloadExport(event.idWorldEvent)"
              :value="
                $anm22.strLang(lang, 'Ticket export', 'Esporta biglietti')
              "
            />
          </div>
          <div class="export">
            <input
              type="button"
              class="com-anm22-input-button"
              @click="downloadParkingExport(event.idWorldEvent)"
              :value="
                $anm22.strLang(lang, 'Parking export', 'Esporta parcheggi')
              "
            />
          </div>
          <div class="export">
            <input
              type="button"
              class="com-anm22-input-button"
              @click="openVehicleCheck(event.idWorldEvent)"
              :value="
                $anm22.strLang(lang, 'Vehicle plate checker', 'Verifica targhe')
              "
            />
          </div>
        </div>
        <div v-else class="event-box">
          <div
            v-for="(subeventShift, shiftIndex) in subeventShifts(event)"
            :key="'key-subevent-' + event.idWorldEvent + '-' + shiftIndex"
            class="export"
          >
            <input
              type="button"
              class="com-anm22-input-button"
              @click="
                openHospitalityList(
                  event.idWorldEvent,
                  subeventShift,
                  event.name + ' - Prenotati turno ' + subeventShift,
                )
              "
              :value="'Prenotati turno ' + subeventShift"
            />
          </div>
          <div class="export">
            <input
              type="button"
              class="com-anm22-input-button"
              @click="
                openMarkedHospitalityTicketsList(
                  event.idWorldEvent,
                  event.name + ' - Pass smarcati',
                )
              "
              :value="'Pass smarcati'"
            />
          </div>
        </div>
      </div>
      <div class="empty-list-msg" v-if="!events || events.length == 0">
        {{ $anm22.strLang(lang, "No events.", "Nessun evento.") }}
      </div>
    </div>

    <div class="vertical-height-div" style="height: 20px"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WGPageControls from "../../../../world/spa/components/WGPageControls.vue";

export default {
  components: {
    WGPageControls,
  },
  data() {
    return {
      ticketType: null,
      ticketTypeEvents: [],
      events: [],
      ticketTypes: [],
      mode: "edit",
      openModal: false,
      currentTicket: {},
      pageResultsNum: 50,
      pageOffset: 0,
      eventAnalytics: {},
      showEventAnalytics: false,
      showHospitalityList: false,
      hospitalityListMode: "reservation",
      hospitalityListTitle: "",
      hospitalityTickets: [],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    ticketTypeId() {
      return this.$route.params.id;
    },
    sortedHospitalityTickets() {
      return [...this.hospitalityTickets].sort(this.ticketsSorting);
    },
  },
  methods: {
    loadData() {
      this.$http
        .get("tickets/analytics/")
        .then((response) => {
          this.ticketType = response.data.cardType;
          this.ticketTypeEvents = response.data.cardTypeEvents;
          this.events = response.data.events;
          this.ticketTypes = response.data.cardTypes;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getEventName(event) {
      if (
        event.jsonData &&
        typeof event.jsonData === "object" &&
        !Array.isArray(event.jsonData) &&
        event.jsonData.motorsportCategory
      ) {
        return (
          event.jsonData.motorsportCategory.toUpperCase() + " " + event.name
        );
      } else {
        return event.name;
      }
    },
    downloadExport(eventId) {
      window.open(
        process.env.VUE_APP_BACK_DOMAIN +
          process.env.VUE_APP_BACK_BASE_URL +
          "spa/controller/tickets/siae-export?event=" +
          eventId,
        "_target",
      );
    },
    downloadParkingExport(eventId) {
      window.open(
        process.env.VUE_APP_BACK_DOMAIN +
          process.env.VUE_APP_BACK_BASE_URL +
          "spa/controller/tickets/parking-export?event=" +
          eventId,
        "_target",
      );
    },
    openVehicleCheck(eventId) {
      window.open(
        "https://civ.anm22.it/gate-vehicle.html?r=" + eventId,
        "_blank",
      );
    },
    openEventAnalytics(eventId) {
      this.$http
        .get("tickets/analytics-event/?event=" + eventId)
        .then((response) => {
          this.eventAnalytics = response.data;
          this.showEventAnalytics = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openHospitalityList(eventId, slot, title) {
      this.$http
        .get("tickets/hospitality-list/?slotKey=" + eventId + "-" + slot)
        .then((response) => {
          this.hospitalityTickets = response.data.tickets;
          this.hospitalityListTitle = title;
          this.hospitalityListMode = "reservation";
          this.showHospitalityList = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openMarkedHospitalityTicketsList(eventId, title) {
      this.$http
        .get("tickets/hospitality-marked-tickets/?event=" + eventId)
        .then((response) => {
          this.hospitalityTickets = response.data.tickets;
          this.hospitalityListTitle = title;
          this.hospitalityListMode = "gate";
          this.showHospitalityList = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    isSubevent(event) {
      return [63071, 63072, 58740, 58743, 63190, 63191].includes(
        event.idWorldEvent,
      );
    },
    subeventShifts(event) {
      if ([63071, 63072, 58740, 58743].includes(event.idWorldEvent)) {
        return [1, 2, 3];
      } else {
        return [1];
      }
    },
    ticketsSorting(a, b) {
      const last = a.lastName.localeCompare(b.lastName);
      if (last !== 0) return last;

      return a.firstName.localeCompare(b.firstName);
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.events-list {
  overflow-x: auto;

  .event-row {
    border-radius: 8px;
    min-height: 49px;
    padding: 5px;
    max-width: 1700px;

    &.subevent {
      padding-left: 25px;
    }

    &:hover {
      background-color: #ffffff;
    }
    .event-preview {
      min-width: 100%;

      div {
        display: inline-block;
        vertical-align: top;
        white-space: normal;
        padding: 11px;
        flex-wrap: nowrap;

        &.status {
          flex: 1;
          width: 80px;
          min-width: 80px;
          max-width: 80px;

          .status-btn {
            border-radius: 4px;
            width: 18px;
            height: 18px;
            padding: 1px 0 0 0;
            text-align: center;
            font-weight: 500;
            cursor: pointer;

            &.enabled {
              color: #fff;
              background-color: #00c853;
            }
            &.disabled {
              color: #fff;
              background-color: #d50000;
            }
          }
        }
        &.name {
          flex: 1;
          width: 20%;
          min-width: 120px;
        }
        &.date {
          flex: 1;
          width: 70%;
          min-width: 120px;
        }
        &.export {
          flex: 2;
          width: 20%;
          min-width: 120px;
          padding: 0 11px;
        }
      }
    }

    .event-box {
      min-width: 100%;

      .export {
        display: inline-block;
        vertical-align: top;
        white-space: normal;
        padding: 11px;
      }
    }

    &.header {
      div {
        font-weight: 600;

        &.one-event {
          padding: 11px;
        }
      }

      &:hover {
        background: none !important;
      }
    }
  }

  .empty-list-msg {
    padding: 16px;
  }
}

.tickets-list-menu {
  align-items: center;
  max-width: 1700px;
}

.hospitality-list-counter {
  margin-bottom: 10px;
  font-size: 14px;
  text-transform: uppercase;
  color: #777;
  font-weight: bold;
}
.hospitality-list-item {
  margin: 2px 0;
  font-size: 16px;
}
</style>
